export const isHttpScheme = (url: string) => /^https?:\/\//i.test(url);
export const removeImageScheme = (url?: string) => {
  if (!url) return "";
  return url.replace(/^http:\/\//i, "//");
}

export function notZero(value: any): boolean {
  return value !== 0 && value !== "0";
}

export function notNull(value: any): boolean {
  return value !== null && value !== undefined && value !== "";
}

/**
  * 检查城市ID是否无效
  * @param cityId 城市ID
  * @returns boolean 是否无效
  */
export function checkCityIdInvalid(cityId?: number | null): boolean {
  return typeof cityId !== 'number' || cityId <= 0;
}